export default {
  selectedMovesContainerStyles: {
    display: "flex",
    flexDirection: "row" as "row",
    flexWrap: "wrap" as "wrap",
  },
};
